import {
  FsLprCamera,
  FsLprCameraAdvancedMarker,
  FsLprQueryCameraAdvancedMarker,
} from '@lib/vehicle-intelligence';

import { IFsMap } from '../types';

export abstract class FsMapLprCamerasServiceProvider<TMap extends IFsMap> {
  public abstract readonly id: string;
  public abstract readonly geospatialProvider: string;

  // Properties
  public abstract flockAvailable: boolean;
  public abstract flockV3Available: boolean;
  public abstract makesParam: string[];
  public abstract lprCameras: any[];
  public abstract flockMarkers: FsLprCameraAdvancedMarker[];
  public abstract flockV3Markers: FsLprCameraAdvancedMarker[];
  public abstract lprMarkers: FsLprQueryCameraAdvancedMarker[];
  public abstract layerData: FsLprCamera[];
  public abstract isSelected: boolean;
  public abstract lprPermissions: boolean;
  public abstract readonly isAvailable: boolean;

  // DeckGL properties
  public abstract deckGlIconLayer: any;
  public abstract statusLayer: any;

  // Functions
  public abstract getMarkers(): (FsLprCameraAdvancedMarker | FsLprQueryCameraAdvancedMarker)[];
  public abstract onMapLoaded(map: TMap): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
  public abstract openCameraDetails(camera: FsLprCamera): void;
  public abstract getMakesParams(makes: string[], isLayerOn: boolean): void;
  public abstract setMakesParam(makes: string[]): void;
  public abstract setSelected(selected: boolean): void;
  public abstract refreshData(): void;
  public abstract destroy(): void;
}
